import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

const navItems = [
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Products Built" },
  { id: "product-portfolio", label: "Product Cases" },
  // { id: "education", label: "Education" },
  { id: "experience", label: "Work" },
  { id: "awards", label: "Awards" },
  { id: "testimonials", label: "Testimonials" },
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: "home",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.updateActiveSection);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateActiveSection);
  }

  updateActiveSection = () => {
    const sections = navItems.map((item) => item.id);
    const scrollPosition = window.scrollY + 100;

    for (let i = sections.length - 1; i >= 0; i--) {
      const section = document.getElementById(sections[i]);
      if (section && section.offsetTop <= scrollPosition) {
        this.setState({ activeSection: sections[i] });
        break;
      }
    }
  };

  handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
  };

  render() {
    const theme = this.props.theme;
    const { activeSection } = this.state;

    return (
      <Fade top duration={1000} distance="20px">
        <SeoHeader />
        <header className="simple-header">
          <div className="header-content">
            {/* Navigation */}
            <nav className="nav">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  className={`nav-link ${
                    activeSection === item.id ? "active" : ""
                  }`}
                  onClick={() => this.handleNavClick(item.id)}
                  style={{ color: theme.text }}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
        </header>
      </Fade>
    );
  }
}
export default Header;
